// The Ink primitive from the design system: text appearing at a calm writing
// pace with a pen tip at the trailing edge, never a spinner.
//
// Shared by the marketing demo and the preview page's reading ledger so both
// write at the same rhythm. Standalone by design — no Turbo, no Stimulus, no
// app code — because the marketing bundle has none of those.

export const INK_BASE_MS = 24

export const inkDelay = (char) => {
  if (char === " ") return 55
  if (",;:".includes(char)) return 100
  if (char === "-") return 80
  if (".!?".includes(char)) return 160
  return INK_BASE_MS
}

export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

// Rewrites an element's own text one character at a time. textContent only:
// on the preview page the strings are page titles from a site we do not
// control, on an origin that carries the attribution cookie.
//
// shouldContinue is checked between characters. A page that rewrites the same
// element when its state changes (the preview's pen line) passes a token check
// here, or two overlapping runs interleave their letters into one element.
export const writeInInk = async (element, { text = null, keepDot = false, shouldContinue = null } = {}) => {
  const source = (text ?? element.textContent).replace(/\s+/g, " ").trim()
  element.textContent = ""

  const dot = document.createElement("span")
  dot.className = "ink-dot"
  dot.setAttribute("aria-hidden", "true")
  element.append(dot)

  for (const char of source) {
    const span = document.createElement("span")
    span.className = "ink-char"
    span.textContent = char
    dot.before(span)
    await wait(inkDelay(char))
    if (shouldContinue && !shouldContinue()) return
  }

  if (keepDot) return

  dot.classList.add("ink-dot--lift")
  await wait(420)
  dot.remove()
}
